import meal from "../assets/meal.mp4";

import bg from "../assets/bg.png";
import chef from "../assets/chef.png";
import gallery01 from "../assets/gallery01.png";
import gallery02 from "../assets/gallery02.png";
import gallery03 from "../assets/gallery03.png";
import gallery04 from "../assets/gallery04.png";
import gallery05 from "../assets/gallery05.png";
import gallery06 from "../assets/gallery06.png";
import gallery07 from "../assets/gallery07.png";
import gallery08 from "../assets/gallery08.png";
import gallery09 from "../assets/gallery09.png";
import gallery10 from "../assets/gallery10.png";
import gallery11 from "../assets/gallery11.png";
import gallery12 from "../assets/gallery12.png";
import gallery13 from "../assets/gallery13.png";
import gallery14 from "../assets/gallery14.png";
import gallery15 from "../assets/gallery15.png";
import knife from "../assets/knife.png";
import menu from "../assets/menu-alt.png";
import overlaybg from "../assets/overlaybg.png";
import spoon from "../assets/spoon.svg";
import welcome from "../assets/steak.jpg";
import findus from "../assets/findus.png";
import laurels from "../assets/lourel.jpg";
import award01 from "../assets/award01.png";
import award02 from "../assets/award02.png";
import award03 from "../assets/award03.png";
import award05 from "../assets/award05.png";
import quote from "../assets/quote.png";

export const images = {
  bg,
  chef,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery15,
  knife,
  menu,
  overlaybg,
  spoon,
  welcome,
  findus,
  laurels,
  award01,
  award02,
  award03,
  award05,
  quote,
  meal,
};

// export default { images, meal, data };
